interface VideoPlayerProps {
  title: string;
  episode: number;
  poster: string;
}

export default function VideoPlayer({ title, episode, poster }: VideoPlayerProps) {
  return (
    <div className="relative overflow-hidden rounded-lg bg-foreground-950">
      <div className="relative" style={{ aspectRatio: "16 / 9" }}>
        <img
          src={poster}
          alt={`${title} 播放画面预览`}
          className="h-full w-full object-cover object-top opacity-40"
        />
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 px-6 text-center">
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-500 text-background-50 md:h-20 md:w-20">
            <i className="ri-play-fill text-3xl md:text-4xl" />
          </span>
          <div key={episode} className="animate-fade-up">
            <p className="font-heading text-lg font-bold text-background-50 md:text-xl">
              {title} · 第 {episode} 集
            </p>
            <p className="mt-1 text-sm text-background-100/80">播放功能待接入，当前为演示界面</p>
          </div>
        </div>
        <span className="absolute left-4 top-4 flex items-center gap-1.5 rounded-md bg-accent-500 px-3 py-1 text-xs font-semibold text-background-50">
          <i className="ri-information-line" />
          演示模式
        </span>
      </div>

      <div className="flex items-center gap-2 border-t border-foreground-800 px-4 py-3 text-xs text-background-100/70">
        <i className="ri-tools-line" />
        本站暂未接入真实视频播放接口，播放区域仅用于展示布局与交互效果。
      </div>
    </div>
  );
}